export const HOMEPAGE = "senologiaWeb"
export const GET = 'GET';
export const POST = 'POST';

export const TIPI_LAYOUT = {
  PTV: "0",
  RM1: "1"
}

export const TIPI_RISPOSTE = {
  COMBO: "combo",
  NUMERO: "numero",
  TESTO: "testo",
  EMAIL: "email",
  DATA: "data"
}

export const MODULO_ANAMNESTICO = {
  SENOLOGIA: 1,
  COLON_RETTO: 3,
  TICKET_PS_STRANIERI: 5
};
export const MODULO_GRADIMENTO = {
  SENOLOGIA: 2,
  COLON_RETTO: 4
};

export const TIPO_HOME = {
  QUESTIONARIO: 1,
  GRADIMENTO: 2
}